module.exports = __webpack_public_path__ + "img/BCH.1b484474.svg";